import React, { forwardRef } from "react";

const TransformSection = forwardRef(({ imageSrc, altText, heading, paragraph, points, ticons }, ref) => {
  return (
    <section ref={ref} className="flex flex-col lg:flex-row items-center gap-10 md:gap-20 px-4 md:px-6 py-8 md:py-12 max-w-6xl mx-auto">
      {/* Left Side - Image */}
      <div className="w-full lg:w-1/2 flex justify-center">
        <img
          src={imageSrc}
          alt={altText}
          className="rounded-lg shadow-lg w-full max-w-sm md:max-w-md lg:max-w-full h-auto object-cover"
        />
      </div>

      {/* Right Side - Content */}
      <div className="w-full lg:w-1/2">
        <h2 className="text-xl md:text-3xl font-bold text-secondary text-center">{heading}</h2>

        {/* Points List */}
        <ul className="mt-4 md:mt-10 space-y-3 md:space-y-4">
          {points.map((point, index) => (
            <li key={index} className="flex gap-2 md:gap-3 text-gray-700">
              <span className="text-green-600 text-md md:text-xl">{ticons[index] || ticons[0]}</span>
              <span className="text-sm md:text-base">{point}</span>
            </li>
          ))}
        </ul>
        <p className="text-center text-black mt-4 text-sm md:text-base md:mt-6">{paragraph}</p>
      </div>
    </section>
  );
});

// Ensure display name for debugging
TransformSection.displayName = "TransformSection";

export default TransformSection;
